export const createStripedPattern = (fillColor: string): HTMLCanvasElement => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = 10;
    canvas.height = 10;

    if (ctx) {
        ctx.fillStyle = fillColor;
        ctx.fillRect(0, 0, 10, 10);

        ctx.strokeStyle = '#ffffff';
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(20, 20);
        ctx.moveTo(0, 10);
        ctx.lineTo(20, 30);
        ctx.moveTo(-10, 0);
        ctx.lineTo(10, 20);
        ctx.stroke();
    }

    return canvas;
};
